/* eslint-disable jsx-a11y/anchor-is-valid */
import * as React from 'react' // Explicitly import React
import {useState, useEffect, useMemo} from 'react' // Added useMemo
import {useDispatch} from 'react-redux'
import {shallowEqual, useSelector} from 'react-redux'
import {RootState} from '../../../../setup'
import * as auth from '../../../../app/modules/auth/redux/AuthRedux'
import {matchConsumerId} from '../../utility'
import './style.css'
import {confirmAlert} from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css' // Import css
import axios from 'axios'
import {useLocation} from 'react-router-dom'
import {PageTitle} from '../../../../_metronic/layout/core'
import DataTable from 'react-data-table-component' // Added DataTable import
export interface itemObject {
  inviteeEmail?: string
  userRole?: string
  status?: string
  inviteeRole?: string
}
export function Team() {
  const [roles, setRoles] = useState([])
  const [userRole, setUserRole] = useState('')
  const [invitedUsers, setInvitedUsers] = useState([])
  const [email, setEmail] = useState('')
  const [pending, setPending] = useState(true) // Added pending state
  const dispatch = useDispatch()
  const query = useLocation()
  const location = query.search || ''

  const user: any = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as any
  const {
    user: {id, email: userEmail},
  } = user

  useEffect(() => {
    console.log({id})
    if (id) {
      matchConsumerId(id, dispatch, auth)
    }
  }, [id])

  useEffect(() => {
    if (userEmail) {
      setEmail(userEmail)
    }
  }, [userEmail])

  useEffect(() => {
    if (userEmail) {
      setEmail(userEmail)
    }
  }, [userEmail])

  useEffect(() => {
    setPending(true) // Set pending to true before fetching
    axios
      .get(`${process.env.REACT_APP_API_URL_BACKEND_LOCAL}/get-invitee${location}`)
      .then((response) => {
        setInvitedUsers(response.data.invitee)
      })
      .finally(() => {
        setPending(false) // Set pending to false after fetching
      })
  }, [])

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL_BACKEND_LOCAL}/get-roles`).then((response) => {
      setRoles(response.data.roles)
    })
  }, []) // The roles fetching doesn't affect the table's pending state directly, so no setPending here.

  const onChangeUserRole = (e: any) => {
    setUserRole(e.target.value)
  }

  const onChangeUserEmail = (e: any) => {
    setEmail(e.target.value)
  }

  const cancelInviteOrDelete = (type: string, email?: string) => {
    let url
    confirmAlert({
      title: 'Confirm to delete this team member',
      message: 'Are you sure you want to delete this invitee / team member.',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            url = `${process.env.REACT_APP_API_URL_BACKEND_LOCAL}/delete-invite`
            axios.get(`${url}?email=${email}`).then((response) => {
              alert(`Member has been ${type}`)
              window.location.reload()
            })
          },
        },
        {
          label: 'No',
          onClick: () => {
            console.log('No')
          },
        },
      ],
    })
  }
  const onSubmit = (e: any) => {
    e.preventDefault()

    if (email === userEmail) {
      alert('Cannot invite yourself.')
      return
    }

    const obj = {
      userRoles: userRole,
      email: email,
    }
    axios
      .post(`${process.env.REACT_APP_API_URL_BACKEND_LOCAL}/send-invite/${location}`, obj)
      .then((response) => {
        alert('Invite has been sent successfully')
        window.location.reload()
      })
  }
  const capitalize = (s) => s && s[0].toUpperCase() + s.slice(1)
  const columns = useMemo(
    () => [
      {
        name: 'Email',
        selector: (row: itemObject) => row.inviteeEmail,
        sortable: true,
      },
      {
        name: 'Role',
        selector: (row: itemObject) => capitalize(row.inviteeRole),
        sortable: true,
      },
      {
        name: 'Status',
        selector: (row: itemObject) => capitalize(row.status),
        sortable: true,
      },
      {
        name: 'Action',
        cell: (row: itemObject) => (
          <div className='action-buttons'>
            <span className='btn btn-delete'>
              <i
                className='btn-icon bi bi-trash3-fill'
                onClick={() => cancelInviteOrDelete('DELETED', row.inviteeEmail)}
              ></i>
            </span>
          </div>
        ),
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
        width: '100px', // Adjust width as needed
      },
    ],
    [cancelInviteOrDelete, capitalize] // Add dependencies for useMemo
  )

  const customStyles = {
    table: {
      style: {
        paddingLeft: '20px',
        paddingRight: '20px',
      },
    },
    headRow: {
      style: {
        backgroundColor: '#f0f0f0',
        minHeight: '40px',
      },
    },
    headCells: {
      style: {
        fontSize: '1rem',
        color: '#495057',
        paddingLeft: '10px',
        paddingRight: '5px',
        fontWeight: '600',
      },
    },
    cells: {
      style: {
        paddingLeft: '10px',
        paddingRight: '5px',
        fontSize: '0.9rem',
      },
    },
    rows: {
      style: {
        '&:nth-child(even)': {
          backgroundColor: '#f8f9fa',
        },
        minHeight: '45px',
      },
    },
    pagination: {
      style: {
        backgroundColor: '#ffffff',
        color: '#333',
      },
    },
  }

  return (
    <div> {/* Changed Fragment to div */}
      <PageTitle breadcrumbs={[]}>Team Management</PageTitle> {/* Corrected typo */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '30px',
        }}
      >
        <div className='col-6'>
          <h5 className='para-1'>{invitedUsers && invitedUsers.length} Team Member(s)</h5>
        </div>
        <div className='col-6 button-invite-2' style={{textAlign: 'right'}}>
          <button
            type='button'
            className='secondary-button btn btn-sm'
            data-bs-toggle='modal'
            data-bs-target='#staticBackdrop'
          >
            Invite Member
          </button>
        </div>
      </div>
      <DataTable
        title={<h4 style={{marginTop: '40px', marginBottom: '40px'}}>Team Members</h4>}
        data={invitedUsers}
        columns={columns}
        pagination
        progressPending={pending}
        progressComponent={
          <div style={{fontSize: '1.35rem'}}>
            <div className='d-flex justify-content-center mb-5'>
              <div className='spinner-border text-primary'>
                <span className='sr-only'>Please wait...</span>
              </div>
            </div>
          </div>
        }
        customStyles={customStyles}
        noDataComponent={<p style={{fontSize: '13px', textAlign: 'center', padding:'20px'}}>There are no records to display</p>} // Custom no data component
      />
      {/* Modal */}
      <div
        className='modal fade'
        id='staticBackdrop'
        data-bs-backdrop='static'
        data-bs-keyboard='false'
        tabIndex={-1}
        aria-labelledby='staticBackdropLabel'
        aria-hidden='true'
      >
        <div className='modal-dialog modal-dialog-centered d-flex justify-content-center'>
          <form style={{width: '70%'}} onSubmit={onSubmit}>
            <div className='modal-content'>
              <div className='modal-header'>
                <h5 className='modal-title' id='staticBackdropLabel'>
                  Invite Member
                </h5>
                <button
                  type='button'
                  className='btn-close'
                  data-bs-dismiss='modal'
                  aria-label='Close'
                />
              </div>
              <div className='modal-body'>
                <div className='mb-3'>
                  <label htmlFor='exampleFormControlTextarea1' className='form-label'>
                    Role
                  </label>
                  <select
                    className='form-select'
                    aria-label='Default select example'
                    name='userRole'
                    onChange={onChangeUserRole}
                    value={userRole}
                  >
                    <option selected>Select role</option>
                    {roles &&
                      roles.length > 0 &&
                      roles.map((item) => <option value={item}>{capitalize(item)}</option>)}
                  </select>
                </div>

                <div className='mb-3'>
                  <label htmlFor='exampleFormControlInput1' className='form-label'>
                  Email address
                </label>
                  <input
                    name='email'
                    onChange={onChangeUserEmail}
                    type='email'
                    className='form-control'
                    id='exampleFormControlInput1'
                    placeholder='name@example.com'
                    required
                  />
                </div>
              </div>
              <div className='modal-footer'>
                <button
                  type='button'
                  className='secondary-button btn btn-sm'
                  data-bs-dismiss='modal'
                >
                  Cancel
                </button>
                <button type='submit' className='secondary-button btn btn-sm'>
                  Invite
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}
